<template>
  <div class="sidebar-pinned ">
    <Navbar/>

    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-grid" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Hello, {{auth_user.agency_name}}</h4>
              <small style="opacity: .8;">Overview of your agency's clients, plans and providers</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- Stat Cards -->
        <div class="row mb-4">
                <div class="col-lg-3 col-md-6 mb-3">
                    <div class="stat-card stat-card--blue">
                      <div class="stat-icon">
                        <i class="fe fe-database"></i>
                      </div>
                      <div>
                        <p class="stat-label">Revenue</p>
                        <h3 class="stat-value">&#8358;1,500</h3>
                      </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 mb-3">
                    <div class="stat-card stat-card--green">
                      <div class="stat-icon">
                        <i class="fe fe-users"></i>
                      </div>
                      <div>
                        <p class="stat-label">Clients</p>
                        <h3 class="stat-value">{{clients.length}}</h3>
                      </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 mb-3">
                    <div class="stat-card stat-card--purple">
                      <div class="stat-icon">
                        <i class="fe fe-credit-card"></i>
                      </div>
                      <div>
                        <p class="stat-label">Plans</p>
                        <h3 class="stat-value">{{plans.length}}</h3>
                      </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 mb-3">
                    <div class="stat-card stat-card--orange">
                      <div class="stat-icon">
                        <i class="fe fe-activity"></i>
                      </div>
                      <div>
                        <p class="stat-label">Providers</p>
                        <h3 class="stat-value">{{providers.length}}</h3>
                      </div>
                    </div>
                </div>

        </div>

        <div class="row">
                <div class="col-md-12 mb-3">
                    <div class="card table-card shadow">
                      <div class="d-flex align-items-center px-4 pt-4 pb-3">
                        <i class="fe fe-activity text-primary mr-2"></i>
                        <h6 class="mb-0 font-weight-bold">Overview</h6>
                      </div>
                      <div class="card-body pt-0">
                          <div class="apexcharts-canvas" id="chart-06"></div>
                      </div>
                    </div>
                </div>
        </div>

        <div class="row">
                <div class="col-md-6 mb-3">
                    <div class="card table-card shadow">
                      <div class="d-flex align-items-center px-4 pt-4 pb-3">
                        <i class="fe fe-users text-primary mr-2"></i>
                        <h6 class="mb-0 font-weight-bold">Employees</h6>
                      </div>
                      <div class="table-responsive">
                        <table class="table align-td-middle mb-0">
                            <thead class="table-head">
                            <tr>
                                <th class="table-th">Name</th>
                                <th class="table-th">Position</th>
                                <th class="table-th">Start date</th>
                                <th class="table-th">Salary</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="table-row">
                                <td>John Bellion</td>
                                <td>System Architect</td>
                                <td>2011/04/25</td>
                                <td>$320,800</td>
                            </tr>

                            </tbody>
                        </table>
                      </div>
                    </div>
                </div>

                <div class="col-md-6 mb-3">
                    <div class="card table-card shadow">
                      <div class="d-flex align-items-center justify-content-between px-4 pt-4 pb-3">
                        <div class="d-flex align-items-center">
                          <i class="fe fe-alert-circle text-primary mr-2"></i>
                          <h6 class="mb-0 font-weight-bold">Claims</h6>
                        </div>
                        <router-link to="/claims-statistics" class="btn btn-outline-info btn-sm">
                            <i class="fe fe-bar-chart-2"></i> Claims Statistics
                        </router-link>
                      </div>
                      <div class="table-responsive">
                        <table class="table align-td-middle mb-0">
                            <thead class="table-head">
                            <tr>
                                <th class="table-th">Name</th>
                                <th class="table-th">Diagnosis</th>
                                <th class="table-th">Seen date</th>
                                <th class="table-th">Cost</th>
                                <th class="table-th">Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="table-row" v-for="claim in claims" v-bind:key="claim.id">
                                <td>
                                  {{claim.client_name}}
                                </td>
                                <td>{{claim.diagnosis}} </td>
                                <td>{{claim.seen_date}}</td>
                                <td><i class="mdi mdi-currency-ngn"></i> {{claim.cost | numeral('0,0.00')}}</td>
                                <td>
                                  <span v-if="claim.status == 1" class="badge badge-soft-success">approved</span>
                                  <span v-if="claim.status != 1" class="badge badge-soft-warning">pending</span>
                                </td>
                            </tr>


                            </tbody>
                        </table>
                      </div>
                    </div>
                </div>

        </div>

      </div>

</main>

    </div>

</template>

<script>
import Navbar from '@/views/Navbar.vue'

export default {
  components: {
     Navbar
  },
  data(){
    return{
      user:null,
      auth_user:"",
      providers:"",
      clients:"",
      claims:"",
      plans:"",

    }
  },
  beforeMount(){
    this.axios.get(`/api/v1/auth/user`)
                .then(response => {
                    this.auth_user = response.data.data
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{
    getProviders(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/providerAgency/${this.user.id}`)
                  .then(response => {
                      this.providers = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getClaims(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/getClaims/${this.user.id}`)
                  .then(response => {
                      this.claims = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getPlans(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/planAgency/${this.user.id}`)
                  .then(response => {
                      this.plans = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getClients(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/getSubsAgency/${this.user.id}`)
                  .then(response => {
                      this.clients = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    }
  },
  created(){
    this.getProviders()
    this.getClaims()
    this.getPlans()
    this.getClients()
  }
}
</script>
<style lang="css" scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
}
.header-icon-wrap {
  width: 48px; height: 48px;
  background: rgba(255,255,255,0.15);
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.stat-card {
  display: flex;
  align-items: center;
  gap: 18px;
  border-radius: 14px;
  padding: 22px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, .08);
  color: #fff;
  height: 100%;
}
.stat-card--blue { background: linear-gradient(135deg, #1e3a5f, #2563eb); }
.stat-card--purple { background: linear-gradient(135deg, #4c1d95, #7c3aed); }
.stat-card--green { background: linear-gradient(135deg, #065f46, #10b981); }
.stat-card--orange { background: linear-gradient(135deg, #9a3412, #f97316); }
.stat-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(255, 255, 255, .2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}
.stat-label {
  margin: 0;
  font-size: .78rem;
  text-transform: uppercase;
  letter-spacing: .05em;
  opacity: .85;
}
.stat-value {
  margin: 2px 0 0;
  font-weight: 700;
}
.table-card { border-radius: 12px; border: 1px solid #e9ecef; overflow: hidden; }
.table-head { background: #f8fafc; }
.table-th {
  font-size: 0.73rem; text-transform: uppercase; letter-spacing: 0.04em;
  color: #64748b; font-weight: 600;
  border-bottom: 2px solid #e2e8f0; padding: 12px 16px;
}
.table-row:hover { background: #f8fafc; }
</style>
